import { setWeek as setWeekFns } from 'date-fns';

export default function setWeek(
  date: Date,
  week: number,
  sundayStart: boolean,
): Date {
  const weekStartsOn = sundayStart ? 0 : 1;
  return setWeekFns(date, week, { weekStartsOn });
}
